export default function Solution() {
  const solutions = [
    {
      icon: 'ri-chat-4-line',
      title: '社内ナレッジAIチャットbot',
      description: 'ベテランの経験・手順・ノウハウをAIに学習させ、誰でも即座に回答を得られる環境を構築。担当者不在でも業務が止まらない体制を作ります。',
      image: '/assets/solution-knowledge-chatbot.jpg'
    },
    {
      icon: 'ri-search-line',
      title: 'マニュアル・規格 検索AIチャットbot',
      description: '膨大な設備マニュアルや品質規格をAIが瞬時に検索・回答。「探す時間」を大幅に削減し、正確な情報に素早くアクセスできます。',
      image: '/assets/solution-manual-search.jpg'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'PLCプログラム・NCコード解析・生成',
      description: 'PLCニーモニックやNCコードをAIで解析・自動生成し、作成工数を削減。専門パートナー企業との協業で高精度に対応します。',
      image: '/assets/solution-plc-code.jpg'
    },
    {
      icon: 'ri-file-text-line',
      title: '紙帳票・作業記録のデジタル化',
      description: '日報・検査帳票・作業日誌をOCRで自動データ化。手入力の手間を省き、蓄積データを改善活動に活かせる環境を整えます。',
      image: '/assets/solution-digitize-forms.jpg'
    },
    {
      icon: 'ri-dashboard-line',
      title: '生産・品質データ可視化ダッシュボード',
      description: '散在するデータを統合・グラフ化。傾向の把握や異常の早期検知を可能にし、現場改善の意思決定をスピードアップします。',
      image: '/assets/solution-dashboard-visual.jpg'
    },
    {
      icon: 'ri-line-chart-line',
      title: '品質データ分析・不良原因特定',
      description: '品質データのパターンをAIで解析し、不良の根本原因を特定。対症療法から脱し、再発しない改善へ導きます。',
      image: '/assets/solution-quality-analysis.jpg'
    }
  ];

  return (
    <section id="solution" className="bg-[#FAFBFC] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#4A5568] text-xs font-bold tracking-widest uppercase mb-4">SOLUTION</p>
          <h2 className="text-4xl font-black text-[#1A3A5C] mb-4">AIによる製造現場の課題解決</h2>
          <p className="text-[#4A5568] text-base">製造現場の課題に対する、EngiMindのアプローチ</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer"
              style={{ minHeight: '280px' }}
            >
              {/* Background Image */}
              <img
                src={solution.image}
                alt={solution.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d2240]/90 via-[#1A3A5C]/60 to-[#1A3A5C]/30"></div>
              {/* Content */}
              <div className="relative z-10 p-8 flex flex-col h-full" style={{ minHeight: '280px' }}>
                <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-5 border border-white/30">
                  <i className={`${solution.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{solution.title}</h3>
                <p className="text-white/85 text-sm leading-relaxed">{solution.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}